import { DataValidationError } from "constants/DataValidationError";
import { IsArray, IsNotEmpty } from "class-validator";

export default class CreateRecruitingMediaReq {
  @IsNotEmpty({ message: DataValidationError.DATA_IS_EMPTY })
  name!: string;

  @IsNotEmpty({ message: DataValidationError.DATA_IS_EMPTY })
  cost!: number;

  @IsArray()
  shops!: number[];

  constructor(arg: any) {
    arg = arg || {};
    this.name = arg.name;
    this.cost = arg.cost;
    this.shops = arg.shops;
  }
}
